module.exports = __webpack_public_path__ + "img/My-Photo__MYP0770_MW.2d4281d6.jpg";